import * as React from 'react';
import type { UserProfile } from '../../utils/interfaces';
import { parseNestedProfile, orderProfileForDisplay } from '../../utils/profileUtils';

export interface DebugViewProps {
  userProfile: UserProfile;
}

export const DebugView: React.FC<DebugViewProps> = ({ userProfile }) => {
  return (
    <div className="user-profile-display" style={{ marginBottom: '1rem', padding: '1rem', background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '8px' }}>
      <h3>User Profile (Debug View)</h3>
      <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '0.9rem', color: '#333' }}>
  {JSON.stringify(orderProfileForDisplay(parseNestedProfile(userProfile)), null, 2)}
      </pre>
    </div>
  );
};
